<template>
    <b-card class="shadow-sm" header-bg-variant="" header-text-variant="black">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Details</h5>
                <div>
                    <b-button
                        v-if="isEditable"
                        key="save"
                        size="sm"
                        variant="success"
                        class="mr-2"
                        @click="onSave"
                    >
                        Save
                    </b-button>
                    <b-button
                        v-if="!isEditable"
                        key="edit"
                        size="sm"
                        variant="sharp-primary"
                        @click="onEdit"
                    >
                        <b-icon icon="pencil" class="mr-2"></b-icon>
                        Edit
                    </b-button>
                    <b-button
                        v-else-if="isEditable"
                        key="cancel"
                        size="sm"
                        variant="secondary"
                        @click="onEditCancel"
                    >
                        Cancel
                    </b-button>
                </div>
            </div>
        </template>
        <ResourceFields
            ref="fields"
            :resource="resource"
            :is-editable="isEditable"
            @saved="onSaved"
        />
    </b-card>
</template>

<script>
import ResourceFields from "@/components/resources/ResourceFields";

export default {
    components: { ResourceFields },
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditable: false,
        }
    },
    methods: {
        onEdit() {
            this.isEditable = true;
        },
        onEditCancel() {
            this.isEditable = false;
            this.$refs.fields.reset(this.resource);
        },
        onSave(params = {}) {
            this.isRedirect = params.isRedirect;
            this.$refs.fields.save();
        },
        onSaved(resource) {
            this.$emit("saved", resource);

            this.onEditCancel();
        },
    },
    created() {
        // TODO: type should come from backend
        this.resource.type = 'Vendor'
    }
};
</script>
